<div mat-dialog-title>
  <span>{{ 'VERSIONING.READY_FOR_AUTHORISATION_TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<ng-container *ngIf="step() === 1">
  <mat-dialog-content>
    <form [formGroup]="form" #formTemplate="ngForm" class="form-content">
      <q9-release-select formControlName="release"></q9-release-select>

      <mat-slide-toggle formControlName="override" class="override-toggle">
        {{ 'VERSIONING.OVERRIDE_AUTHORISATION_LABEL' | translate }}
      </mat-slide-toggle>

      <q9-datetime-picker
        formControlName="requiredBy"
        [label]="'VERSIONING.AUTHORISATION_REQ_BY_LABEL'"
        [readonly]="true"></q9-datetime-picker>

      <q9-textarea-field
        formControlName="comment"
        [minRows]="3"
        [maxRows]="5"
        [label]="'COMMENTS.ADD_COMMENT'"></q9-textarea-field>

      <q9-text-field
        *ngIf="havePassword"
        formControlName="password"
        [label]="'POPUPS.ENTER_PASSWORD'"
        type="password"></q9-text-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <mat-slide-toggle [formControl]="childrenControl">
      {{ 'VERSIONING.INCLUDE_LOWER_LEVEL' | translate }}
    </mat-slide-toggle>

    <q9-link-button *ngIf="childrenControl.value" (click)="step.set(2)">
      {{ 'VERSIONING.CHILD_LOWER_LEVELS_INSPECT' | translate }}
    </q9-link-button>

    <q9-secondary-button mat-dialog-close>
      {{ 'VERSIONING.CANCEL_BTN' | translate }}
    </q9-secondary-button>

    <q9-primary-button
      [isLoading]="isLoading()"
      (click)="formTemplate.onSubmit($event); handleOnSubmit()">
      {{ 'VERSIONING.CONFIRM_BTN' | translate }}
    </q9-primary-button>
  </mat-dialog-actions>
</ng-container>

<app-lower-levels-content
  *ngIf="step() === 2"
  [override]="overrideFormControl.value"
  (backToSubmission)="step.set(1)"></app-lower-levels-content>
